import React, { useState, useEffect } from "react";
import { Tooltip } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrash,
  faEye,
  faArrowUpFromBracket,
} from "@fortawesome/free-solid-svg-icons";
import { motion } from "framer-motion";
import axios from "axios";
import { Toaster, toast } from "react-hot-toast";
import { jwtDecode } from "jwt-decode";
import { useNavigate, useLocation } from "react-router-dom";

export default function PreviewForm() {
  const navigate = useNavigate();
  const location = useLocation();
  const { form_inputs } = location.state;
  console.log(location.state);

  return (
    <>
      <Toaster position="bottom-left" reverseOrder={false} />
      <div className="flex justify-center items-center">
        <div className="relative flex flex-col min-w-0 break-words w-full mb-6 mt-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
          <div className="rounded-t bg-white mb-0 px-6 py-6">
            <div className="text-center flex justify-between">
              <h6 className="text-blueGray-700 text-xl font-semibold">
                Event Registrations Form Preview
              </h6>
            </div>
          </div>
          <div className="flex-auto px-4 lg:px-10 py-10 pt-0 mt-3">
            <form>
              <div className="flex flex-wrap">
                {form_inputs.map((input, index) => {
                  const name = input.fieldName
                    .replace(/\s+/g, "_")
                    .toLowerCase();
                  const isFile = input.fieldType === "file";

                  return (
                    <div className="w-full lg:w-6/12 px-4" key={index}>
                      <div className="relative w-full mb-3">
                        <label className="block text-blueGray-600 text-xs font-bold mb-2">
                          {input.fieldName}
                        </label>

                        {input.fieldType === "textarea" ? (
                          <textarea
                            className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full"
                            placeholder={input.fieldName}
                            name={input.fieldName}
                          />
                        ) : input.fieldType === "select" ? (
                          <select
                            className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full"
                            name={input.fieldName}
                          >
                            <option value="">Select {input.fieldName}</option>
                            {(input.options || []).map((opt, i) => (
                              <option key={i} value={opt}>
                                {opt}
                              </option>
                            ))}
                          </select>
                        ) : isFile ? (
                          <>
                            <input
                              id={`file-input-${index}`}
                              type="file"
                              className="hidden"
                            />
                            <div className="flex flex-wrap items-center gap-4 mt-2">
                              <label
                                htmlFor={`file-input-${index}`}
                                className="mr-4"
                              >
                                <span className="cursor-pointer bg-lightBlue-500 text-white active:bg-lightBlue-600 font-semibold text-sm px-4 py-2 rounded shadow hover:shadow-md">
                                  <FontAwesomeIcon
                                    icon={faArrowUpFromBracket}
                                  />{" "}
                                  Upload File
                                </span>
                              </label>
                            </div>
                          </>
                        ) : (
                          <input
                            type={input.fieldType}
                            className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full"
                            placeholder={input.fieldName}
                            name={name}
                          />
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>

              <div className="flex justify-end w-full">
                <Tooltip title="Back" arrow>
                  <button
                    className="mt-10 text-white bg-blueGray-700 active:bg-blueGray-600 font-semibold text-sm px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-auto"
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(-1);
                    }}
                  >
                    {"<< "}Back
                  </button>
                </Tooltip>

                <Tooltip title="Submit" arrow>
                  <button
                    className="bg-lightBlue-500 mt-10 text-white active:bg-lightBlue-600 font-semibold text-sm px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1"
                    type="submit"
                    disabled={true}
                  >
                    Submit
                  </button>
                </Tooltip>

                <Tooltip title="Clear" arrow>
                  <button
                    className="bg-red-500 mt-10 text-white active:bg-red-600 font-semibold text-sm px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1"
                    type="button"
                    disabled={true}
                  >
                    Clear
                  </button>
                </Tooltip>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
